<template>
  <fragment>
    <div class="main_page">
      <app-navbar></app-navbar>
      <div class="page">
        <loading :active.sync="isPageLoading" is-full-page></loading>
        <div v-if="!isPageLoading">
          <div class="page-title">
            <h1>Contact Types</h1>
          </div>
          <div class="page-content">
            <form>
              <div class="form-group row">
                <label for="searchKeyword" class="col-sm-2 col-form-label">Search by Keyword</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="searchKeyword" />
                </div>
                <div class="col-sm-2">
                  <button v-if="$permissions().hasEditContactTypePermission" type="button" class="btn btn-primary" @click="newContactType">
                    <i class="fas fa-plus-circle"></i>
                    Add New
                  </button>
                </div>
              </div>
            </form>
            <ul class="list-group list-group-flush border-bottom">
              <li class="list-group-item d-flex px-2" v-for="contactType in searchLocalDataset(getContactTypes)" :key="contactType.id">
                <div class="mr-auto">
                  <p class="m-0">{{ contactType.name }}</p>
                </div>
                <a role="button" v-if="$permissions().hasEditContactTypePermission" href="#" class="d-flex justify-content-between align-items-center flex-column"
                    title="Edit" @click.prevent="editContactType(contactType.id)">
                  <img class="mb-1" src="@/assets/document.svg" alt />
                  <span class="small-grey">Edit</span>
                </a>
                <a role="button"  v-if="$permissions().hasDeleteContactTypePermission" href="#" class="d-flex justify-content-between align-items-center flex-column ml-3"
                    title="Delete" @click.prevent="deleteContactType(contactType.id)">
                  <img class="mb-1" src="@/assets/red_x.svg" alt />
                  <span class="small-grey">Delete</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-contact-type" size="lg" hide-header hide-footer :no-close-on-backdrop="true">
      <contact-type></contact-type>
    </b-modal>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MessageBox from "@/utils/messagebox";
import Toast from "@/utils/toast";

export default {
  name: "configuration-contact-types",
  components: {
    'app-navbar': () => import('@/components/app-navbar.vue'),
    'contact-type': () => import('@/views/configuration/components/contact-type.vue')
  },
  computed: {
    ...mapGetters(["getContactTypes"])
  },
  data: function() {
    return {
      isPageLoading: true,
      searchKeyword: null
    };
  },
  methods: {
    newContactType() {
      this.resetContactType().then(() => {
        this.$bvModal.show("bv-modal-contact-type");
      });
    },
    editContactType(id) {
      this.fetchContactType(id).then(() => {
        this.$bvModal.show("bv-modal-contact-type");
      });
    },
    async deleteContactType(id) {
      let confirm = await MessageBox.confirm(this, "Remove Contact Type", "Are you sure you want to remove contact type?");

      if (confirm) {
        this.removeContactType(id).then(() => {
          Toast.success(this, "Successfully removed contact type!");
        });
      }
    },
    searchLocalDataset(values) {
      if (!this.searchKeyword || this.searchKeyword === "") return values;

      return values.filter(i => i.name.includes(this.searchKeyword));
    },
    ...mapActions([ "fetchContactType", "fetchContactTypes", "removeContactType", "resetContactType" ])
  },
  mounted: function() {
    this.fetchContactTypes().then(() => {
      this.isPageLoading = false;
    });
  }
};
</script>
